import Navbar from "../components/Navbar";
import HookLibrary from "../components/HookLibrary";
import SeoHead from "../components/seo/SeoHead";

function HookLibraryPage() {
  return (
    <div>
      <SeoHead
        title="Library | Hookora"
        description="Browse saved hooks and studio assets in your Hookora library."
        path="/library"
      />
      <Navbar />
      <HookLibrary />
    </div>
  );
}

export default HookLibraryPage;
